import { ReminderEmailService } from "@/common/api.service"
import { FETCH_REMINDER_EMAIL, FETCH_INDIVIDUAL_REMINDER_EMAIL, ADD_REMINDER_EMAIL, UPDATE_REMINDER_EMAIL,RESET_STATE, DELETE_REMINDER_EMAIL } from "./actions.type"
import { SET_REMINDER_EMAIL, SET_INDIVIDUAL_REMINDER_EMAIL, SET_ERROR_REMINDER_EMAIL,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        reminderemail: [],
        individualreminderemail: [],
        reminderemailerrors: null,
    }
}

let state = initialState()

const getters = {
    reminderemail(state) {
        return state.reminderemail
    },
    individualreminderemail(state) {
        return state.individualreminderemail
    }
}

const actions = {
    async [FETCH_REMINDER_EMAIL](context, slug) {
        const { data } = await ReminderEmailService.get(slug)
        context.commit(SET_REMINDER_EMAIL, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_REMINDER_EMAIL](context, slug) {
        const { data } = await ReminderEmailService.get(slug)
        context.commit(SET_INDIVIDUAL_REMINDER_EMAIL, data.data)
        return data;
    },  
    async [ADD_REMINDER_EMAIL](context, payload) {
        return await ReminderEmailService.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },     
    async [UPDATE_REMINDER_EMAIL](context, payload) {
        return await ReminderEmailService.update(payload, payload.email_temp_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },  
    async [DELETE_REMINDER_EMAIL] (context, email_temp_id) {
        return await ReminderEmailService.delete(email_temp_id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_REMINDER_EMAIL, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_REMINDER_EMAIL](state, error) {
        state.reminderemailerrors = error
    },      
    [SET_REMINDER_EMAIL](state, reminderemaildata) {
        state.reminderemail = reminderemaildata
    },
    [SET_INDIVIDUAL_REMINDER_EMAIL](state, individualreminderemaildata) {
        state.individualreminderemail = individualreminderemaildata
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};